
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useUpdateSkipAllocation = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ 
      orderId, 
      skipAllocation 
    }: {
      orderId: string;
      skipAllocation: boolean;
    }) => {
      console.log("🔄 Updating skip allocation:", orderId, skipAllocation);
      
      const { data, error } = await supabase
        .from('orders')
        .update({
          skip_device_allocation: skipAllocation,
          updated_at: new Date().toISOString()
        })
        .eq('id', orderId)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      queryClient.invalidateQueries({ queryKey: ['order-workflow'] });
      toast({
        title: "Success",
        description: "Skip allocation setting updated successfully",
      });
    },
    onError: (error) => {
      console.error("❌ Error updating skip allocation:", error);
      toast({
        title: "Error",
        description: "Failed to update skip allocation setting",
        variant: "destructive",
      });
    },
  });
};
